var map = {
	"./Abstemio.png": 5524,
	"./Anonymous.png": 5525,
	"./Arbol.png": 5526,
	"./Barney.png": 5527,
	"./Bebe.png": 5528,
	"./Cani.png": 5529,
	"./Cupido.png": 5530,
	"./Dracula.png": 5531,
	"./Hippie.png": 5532,
	"./Homer.png": 5533,
	"./Judio.png": 5534,
	"./Ludopata.png": 5535,
	"./Mago.png": 5536,
	"./Mario.png": 5537,
	"./Medico.png": 5538,
	"./Millonario.png": 5539,
	"./Ninja.png": 5540,
	"./Paleto.png": 5541,
	"./Payaso.png": 5542,
	"./Pirata.png": 5543,
	"./Policia.png": 5544,
	"./Presidente.png": 5545,
	"./Profesor.png": 5546,
	"./SAW.png": 5547,
	"./Santaclaus.png": 5548,
	"./Sheldon.png": 5549,
	"./Spiderman.png": 5550,
	"./Spielberg.png": 5551,
	"./Stripper.png": 5552,
	"./Tecnico.png": 5553,
	"./Thanos.png": 5554,
	"./Vader.png": 5555,
	"./Viejo.png": 5556,
	"./sample.png": 5557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5523;